import template from './adpSidePanel.html';
import controller from './adpSidePanel.controller';
import './adpSidePanel.less';

let adpSidePanelComponent = {
  restrict: 'E',
  bindings: {},
  template,
  transclude: true,
  controller
};

export default adpSidePanelComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSidePanel/adpSidePanel.component.js